import { useUpdateEffect } from "@chakra-ui/react";
import { useCallback, useEffect, useRef, useState } from "react";

export default function useAudioRecorder(
  onDataAvailable: (e: BlobEvent, duration: number) => void = () => null,
) {
  const [isRecording, setIsRecording] = useState(false);
  const mediaRecorder = useRef<MediaRecorder>();
  const startTime = useRef<number | null>(null);

  const startRecording = useCallback(() => {
    startTime.current = Date.now();
    setIsRecording(true);
  }, []);

  const stopRecording = useCallback(() => {
    setIsRecording(false);
  }, []);

  useEffect(() => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      console.warn("Your browser does not support recording!");
      return;
    }
  }, []);

  useUpdateEffect(() => {
    if (isRecording) {
      navigator.mediaDevices
        ?.getUserMedia({ audio: true })
        .then((stream) => {
          mediaRecorder.current = new MediaRecorder(stream);
          mediaRecorder.current.ondataavailable = (e: BlobEvent) =>
            onDataAvailable(e, Date.now() - (startTime.current ?? 0));
          mediaRecorder.current.onstop = function (this) {
            this.stream.getTracks().forEach((track) => track.stop());
          };
          mediaRecorder.current.start();
        })
        .catch(() => console.warn("User has not given audio permission"));
    } else {
      mediaRecorder.current?.stop();
    }
  }, [isRecording, onDataAvailable]);

  return { isRecording, startRecording, stopRecording };
}
